<div class="dnd-input">
  <input type="text" class="dnd-input-control" id="dnd-input-search" name="dnd-input-search" placeholder="Busca"
    autocomplete="off"
    [formControl]="inputForm"
    (change)="searchInput()"
    (keydown)="downList($event)">
  <button class="btn-search" (click)="searchText()">
    <img src="../../assets/svgs/search.svg" alt="search">
  </button>
</div>
<div class="element">
  <ul class="select" *ngIf="flagInput && listSearch.length">
    <li *ngFor="let item of listSearch; let i = index" [ngClass]="{'downRow': indexIdValue === i }" (pointerover)="pointerSelection(i)">
      <a (click)="sendItem(item)" id="list-tags-{{i}}">
        <span class="select-description" [innerHTML]="item.label"></span>
        <div class="badge">
          <p>{{ item.type }}</p>
        </div>
      </a>
    </li>
  </ul>
</div>